import React from 'react';
interface FooterProps {
  onOpenModal: (modalId: 'privacy' | 'terms' | 'disclaimer') => void;
}
export function Footer({
  onOpenModal
}: FooterProps) {
  return <footer className="bg-[#2A1F17] text-[rgba(250,247,242,0.6)] py-10 px-5 text-center font-sans text-[13px]" data-id="element-58">
      <div className="font-serif text-xl text-[#FAF7F2] mb-2" data-id="element-59">B.E.B.E. 365</div>
      <div className="mb-6 italic" data-id="element-60">
        Del instinto de supervivencia al diseño de un desarrollo cognitivo de
        élite
      </div>

      <div className="flex justify-center items-center gap-4 flex-wrap mb-5" data-id="element-61">
        <button onClick={() => onOpenModal('privacy')} className="text-[rgba(250,247,242,0.6)] bg-transparent text-[13px] font-sans transition-colors hover:text-[#FAF7F2] underline underline-offset-2" data-id="element-62">
          Política de Privacidad
        </button>
        <span className="text-[rgba(250,247,242,0.2)]" data-id="element-63">|</span>
        <button onClick={() => onOpenModal('terms')} className="text-[rgba(250,247,242,0.6)] bg-transparent text-[13px] font-sans transition-colors hover:text-[#FAF7F2] underline underline-offset-2" data-id="element-64">
          Términos de Servicio
        </button>
        <span className="text-[rgba(250,247,242,0.2)]" data-id="element-65">|</span>
        <button onClick={() => onOpenModal('disclaimer')} className="text-[rgba(250,247,242,0.6)] bg-transparent text-[13px] font-sans transition-colors hover:text-[#FAF7F2] underline underline-offset-2" data-id="element-66">
          Descargo de Responsabilidad
        </button>
      </div>

      <div className="text-xs text-[rgba(250,247,242,0.4)] mb-5" data-id="element-67">
        © 2026 B.E.B.E. 365. Todos los derechos reservados.
      </div>

      <div className="max-w-[700px] mx-auto text-[11px] text-[rgba(250,247,242,0.3)] leading-relaxed" data-id="element-68">
        Este sitio no es parte de Facebook™ ni de Meta Platforms Inc. Además,
        este sitio NO está respaldado por Facebook™ de ninguna manera.
        FACEBOOK™ es una marca registrada de META PLATFORMS, INC. Los
        resultados mencionados no son típicos. Los resultados individuales
        variarán según el esfuerzo, experiencia y situación de cada familia.
        Este contenido es únicamente para fines educativos e informativos.
        Consulta siempre a tu pediatra para decisiones médicas.
      </div>
    </footer>;
}